import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/shared/components/ui/dialog';

interface ReleaseDialogProps {
  open: boolean;
  onClose: () => void;
  markdown: string;
  version: string;
  releaseDate: string;
}

export default function ReleaseDialog({
  open,
  onClose,
  markdown,
  version,
  releaseDate,
}: ReleaseDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Release Notes — {version}</DialogTitle>
          <DialogDescription>Released on {releaseDate}</DialogDescription>
        </DialogHeader>
        <div className="prose prose-sm dark:prose-invert max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: ({ children, href, ...props }) => <a href={href} target="_blank" rel="noopener noreferrer" {...props}>{children}</a> }}>
            {markdown}
          </ReactMarkdown>
        </div>
      </DialogContent>
    </Dialog>
  );
}
